import { ActionContext } from 'vuex'
import { RootState } from '@/store/RootState'
import AuthState from '@/interfaces/State/AuthState'
import { logout as sessionLogout } from '@/auth/session'

export const logout = async (context: ActionContext<AuthState, RootState>): Promise<void> => {
	await context.dispatch('clearCache')
	// @ts-ignore
	window.NREUM?.setUserId(null)
	sessionLogout()
}

export const clearCache = async (context: ActionContext<AuthState, RootState>): Promise<void> => {
	context.commit('setInitialized', false)
	context.commit('setUser', {})
	context.commit('setPermissions', [])
	context.commit('setVessels', [])
	context.commit('setEmptyVessel', null)
	context.commit('setQueuedEmptyVessel', null)
	context.commit('users/clearCache', null, { root: true })
	context.commit('vessels/clearCache', null, { root: true })
}
